import { createContext, useCallback, useEffect, useState } from "react";
import { io } from "socket.io-client";

const socketContext = {};

// Создаем контекст для сокета
// Этот контекст будет использоваться для передачи сокета через дерево компонентов
// Он будет предоставлять доступ к сокету всем дочерним компонентам, которые его используют
export const SocketContext = createContext(socketContext);
// Провайдер для сокета, далее через кастомные хуки пользоваться сокетом
export default function Connector({ children, url, path }) {
    const [socket, setSocket] = useState(null);

    useEffect(() => {
        const s = io(url, { path, transports: ["websocket", "polling"] });
        setSocket(s);
        return () => { s.disconnect(); setSocket(null); };
    }, [url, path]);

    return (
        <SocketContext.Provider value={{ socket }}>
            {children}
        </SocketContext.Provider>
    );
}